import { t } from "@redotech/redo-i18n";
import { MetafieldMatchType } from "@redotech/redo-return-core-common/condition-options";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  productMetafieldFromModel,
  validateProductMetafieldCondition,
  type ProductMetafieldState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_METAFIELD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ProductMetafieldState>
  >,
): ConditionType<ProductMetafieldState, Condition.ProductMetafield> => ({
  name: CONDITION_NAMES[Condition.PRODUCT_METAFIELD],
  description(state) {
    return t("Metafield: {{metafield}}", {
      metafield: `${state.namespace}.${state.key}`,
    });
  },
  Details(props: ConditionTypeDetailsProps<ProductMetafieldState>) {
    return React.createElement(Details, props);
  },
  empty: {
    namespace: "",
    key: "",
    comparison: MetafieldMatchType.EXACT,
    value: "",
  },
  fromModel(model: Condition.ProductMetafield) {
    return productMetafieldFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_METAFIELD, ...state };
  },
  valid(state) {
    return validateProductMetafieldCondition(state).valid;
  },
});
